export const getConfigDevelopment = () => {
  return {
    devtools: true,
    ssr: false,

    apm: {
      apmRequest: () => false,
    },

    ignoreWebviewGuard: true,
  }
}
